import "./App.css";
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { Topnavbar } from "./components/Topnavbar";
import Home from "./pages/Home";
import Hero from "./pages/Hero";
import CompleteProfile from "./pages/CompleteProfile";
import Profile from "./pages/Profile";
import { UserContext } from "./context/User";
import axios from "axios";
import { NotificationsProvider } from "@mantine/notifications";
function App() {
  const [UserInfo, setUserInfo] = useState({
    username: "",
    avatar: "",
    desc: "",
  });
  useEffect(() => {
    axios
      .get("https://swipett.herokuapp.com/userinfo", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setUserInfo({
          username: res.data.user.username,
          avatar: res.data.user.avatar,
          desc: res.data.user.description,
        });
        setIsLoggedIn(true);
      })
      .catch((err) => {
        setIsLoggedIn(false);
      });
  }, []);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  return (
    <UserContext.Provider
      value={{ isLoggedIn, setIsLoggedIn, UserInfo, setUserInfo }}
    >
      <NotificationsProvider>
        <Router>
          <Topnavbar />

          <Switch>
            <Route path="/" exact component={Hero} />

            <Route path="/Home" exact component={Home} />
            <Route path="/login" exact component={Login} />
            <Route path="/Profile" exact component={Profile} />
            <Route path="/register" exact component={Register} />
            <Route path="/completeprofile" exact component={CompleteProfile} />
          </Switch>
        </Router>
      </NotificationsProvider>
    </UserContext.Provider>
  );
}

export default App;
